import {css} from "styled-components";

export const fontFamily = css`
  @font-face {
    font-family: "NewSpirit";
    src: url("/fonts/new_spirit_medium_condensed_2-webfont.woff2") format("woff2"),
      url("/fonts/new_spirit_medium_condensed_2-webfont.woff") format("woff");
  }
`;
